import { FonteIdadeGestacionalEnum } from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'

export const fonteIdadeGestacionalRecord: Record<FonteIdadeGestacionalEnum, string> = {
  [FonteIdadeGestacionalEnum.DUM]: 'DUM',
  [FonteIdadeGestacionalEnum.US]: 'ecografia',
}

export interface FonteIdadeGestacionalFormModel {
  fonteIg: FonteIdadeGestacionalEnum
}

export const metaFonteIdadeGestacional = metaPath<FonteIdadeGestacionalFormModel>()
